module.exports = __webpack_public_path__ + "static/media/more-icon.04eadd81.svg";